import React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';

function FloatingBar({ color = colors.actionMinor[500], ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path
                fill={color}
                fillRule="evenodd"
                d="M19.777 2c.611 0 1.136.217 1.57.652.436.436.653.96.653 1.57v15.555c0 .611-.217 1.136-.652 1.57-.435.436-.96.653-1.57.653H4.222a2.142 2.142 0 0 1-1.57-.652A2.141 2.141 0 0 1 2 19.778V4.222c0-.611.217-1.135.652-1.57.436-.436.96-.653 1.57-.653h15.555ZM4.223 19.777h15.554V4.223H4.223v15.554ZM17 14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10Z"
            />
        </svg>
    );
}

export default FloatingBar;
